<script setup lang="ts">

</script>

<template>
  <svg width="12" height="9" viewBox="0 0 12 9" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M3.29289 8.70711C3.68342 9.09763 4.31658 9.09763 4.70711 8.70711L11.7071 1.70711C12.0976 1.31658 12.0976 0.683418 11.7071 0.292894C11.3166 -0.0976312 10.6834 -0.0976312 10.2929 0.292894L4 6.58579L1.70711 4.29289C1.31658 3.90237 0.683417 3.90237 0.292893 4.29289C-0.0976311 4.68342 -0.0976311 5.31658 0.292893 5.70711L3.29289 8.70711Z" fill="#6EC431"/>
  </svg>
</template>